import React from 'react';
import Table from 'react-bootstrap/Table';
import { BoxArrowUpRight } from 'react-bootstrap-icons';
import ProductEnrichmentConfidenceBadge from './ProductEnrichmentConfidenceBadge';
import { formatEnrichmentCreatedAt } from '../../utils/productEnrichment';

/**
 * Pending enrichment queue table.
 *
 * @param {Object} props
 * @param {Array<Object>} props.rows
 * @param {function} props.onRowClick
 */
const ProductEnrichmentListTable = ({ rows, onRowClick }) => {
  if (!rows?.length) {
    return null;
  }

  return (
    <Table hover responsive className="mb-0">
      <thead>
        <tr>
          <th>Cat#</th>
          <th>Name</th>
          <th>Supplier</th>
          <th>Confidence</th>
          <th>Warnings</th>
          <th>Source</th>
          <th>Created</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <tr
            key={row.id}
            role="button"
            tabIndex={0}
            style={{ cursor: 'pointer' }}
            onClick={() => onRowClick(row)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onRowClick(row);
              }
            }}
          >
            <td>{row.product_cat_num || '—'}</td>
            <td>{row.product_name || '—'}</td>
            <td>{row.supplier_name || '—'}</td>
            <td>
              <ProductEnrichmentConfidenceBadge
                confidence={row.matched_product_confidence}
              />
            </td>
            <td>{row.warning_count ?? 0}</td>
            <td onClick={e => e.stopPropagation()}>
              {row.source_url ? (
                <a
                  href={row.source_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open source page"
                >
                  <BoxArrowUpRight />
                </a>
              ) : (
                '—'
              )}
            </td>
            <td>{formatEnrichmentCreatedAt(row.created_at)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProductEnrichmentListTable;
